module.exports = __webpack_public_path__ + "static/media/03.cdcd2568.png";